module.exports = __webpack_public_path__ + "static/media/08_3.058dcdf6.png";